export default __webpack_public_path__ + "static/DownArrow-27a80a12ec37dad2d59da85e886fd4bb.png";